import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

// Pure date helper extracted from DayViewCalendarComponent so it can be unit-tested without
// loading the full component, which eagerly imports fullcalendar, swiper, the Agora SDK,
// react-to-pdf, etc. (none of which initialise cleanly under jsdom).
export function goToPreviousDate(selectedDate, setSelectedDate) {
  const previousDate = dayjs(selectedDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY')
  setSelectedDate(previousDate)
  return previousDate
}
